import React, { useState } from 'react';

const DigitalFarming = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="px-4 md:py-[5px] py-4 md:px-24 bg-white">
      <div className="md:text-left md:mb-3 mb-1">
        <h1 className="text-[#FDBD26] font-bold text-[12px] md:text-[40px] md:mt-5 tracking-wide">DIGITAL FARMING</h1>
        <h2 className="text-black text-[12px] md:text-[40px] md:mt-2 md:hidden flex font-bold">Lets Go Namibia!</h2>
        <h2 className="text-black text-[12px] md:text-[40px] md:flex hidden tracking-wide font-bold">Lets Go Namibia!</h2>
      </div>

      <div className="flex md:flex-row md:items-start gap-1 md:gap-10">
        {/* Image on the left */}
        <div className="w-[200px] md:w-1/2 rounded-xl">
          <a href='/news'>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745011981/image_37_tbvafc.png"
              alt="Digital Farming"
              className="md:w-full md:flex hidden md:h-auto object-contain rounded-xl"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745011981/image_37_tbvafc.png"
              alt="Digital Farming"
              className="w-[250px] md:hidden flex h-[100px] object-contain rounded-md"
            />
          </a>
        </div>
     
        {/* Text on the right */}
        <div 
          className="w-[250px] md:w-[550px] relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="cursor-pointer">
            <h1 className="text-black font-bold text-[10px] md:text-[44px]" style={{ lineHeight: '1.10' }}>
              Have you registered as a Farmer?
            </h1>

            <p className="text-black md:text-[30px] text-[8px] leading-7 md:mt-5 mt-1" style={{ lineHeight: '1.15' }}>
            Why Register as a Farmer?
Farmnet is a dynamic network built for African farmers - connecting you to national, continental, and global markets.
Are you a farmer? Then Farmnet is your gateway to visibility, opportunity, and growth....

            </p>
           
          </div>

          {/* Expanded content with animation */}
          <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isHovered ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`}>
            <div className="pt-4 pb-6">
              <h2 className="text-black font-bold text-[16px] md:text-[30px] mb-2">Why Register as a Farmer?</h2>
              <p className="text-black text-[12px] md:text-[30px] leading-relaxed">
                Farmnet is a dynamic network built for African farmers — connecting you to national, continental, and global markets.
                Are you a farmer? Then Farmnet is your gateway to visibility, opportunity, and growth.
                <br /><br />
                By registering with Farmnet, you make it easier for off-takers, contractors, traders, financiers, government agencies, service providers, donors, manufacturers, importers, exporters, and regulators to find and engage with you.
                <br /><br />
                Let the world know:
                <ul className="list-disc list-inside pl-5 mt-2">
                  <li>Who you are</li>
                  <li>Where you are located</li>
                  <li>What you produce</li>
                  <li>When and how you produce it</li>
                  <li>How much you produce</li>
                </ul>
                <br />
                When you're visible, opportunities come to you. Farmnet helps you maximize your reach and profits by putting your farm on the map — literally and commercially.
                <br /><br />
                <span className="font-bold">👉 Register today and let the markets come to you.</span>
              </p>
            </div>
          </div>

          {/* Desktop See More */}
          <div className="md:flex hidden items-center justify-between space-x-10 text-[28px]">
            <strong className="whitespace-nowrap font-normal text-white">accurate agricultural advice,.........</strong>
            <a href='/news'>
              <div className="flex items-center flex-shrink-0 md:mt-2">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748784629/Expand_right_1_oh82zp.png"
                  alt="Expand"
                  className="w-[34px] h-[34px]"
                />
              </div>
            </a>
          </div>

          {/* Mobile See More */}
          <a href='/news'>
            <div className="flex md:hidden justify-end items-center space-x-2 mt-2 text-[10px]">
              <div className="flex items-center flex-shrink-0">
                <p className="bg-[#2E453D] text-white px-2 py-[3px] md:py-1 text-[8px] md:rounded-tl-xl font-bold md:rounded-bl-xl rounded-bl-lg rounded-tl-lg whitespace-nowrap">
                  See more
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                  alt="Expand"
                  className="md:w-[20px] md:h-[20px] h-[18px] w-4 object-contain md:rounded-tr-xl md:rounded-br-xl rounded-tr-lg rounded-br-lg bg-[#152C24] px-1 md:px-[6px] md:py-[2px]"
                />
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className='md:h-10'></div>
    </section>
  );
};

export default DigitalFarming;